import { AfterViewInit, Directive, ElementRef, EventEmitter, Output } from '@angular/core';

export interface ElementSize {
  width: number;
  height: number;
}

@Directive({
  selector: '[elementSize]',
})
export class ElementSizeDirective implements AfterViewInit {
  @Output()
  size = new EventEmitter<ElementSize>();
  constructor(private eleRef: ElementRef) {}
  ngAfterViewInit(): void {
    const ro = new ResizeObserver(() => {
      window.requestAnimationFrame(() => {
        this.size.emit({ width: this.eleRef.nativeElement.offsetWidth, height: this.eleRef.nativeElement.offsetHeight });
      });
    });
    ro.observe(this.eleRef.nativeElement);
    this.size.emit({ width: this.eleRef.nativeElement.offsetWidth, height: this.eleRef.nativeElement.offsetHeight });
  }
}
